module.exports = __webpack_public_path__ + "images/category_lp/common/point-3_953111551d6e7aa437d221544fcd4d04.png";